import React from 'react';

const Condition = () => {
  return <div>Condition</div>;
};

export default Condition;
